jQuery(function($) {
    $(document).ready(function() {

        // Product filter trigger on mobile
        $("#filterTrigger").click(function() {
            $(this).toggleClass('active');
            $(".berocket_single_filter_widget").slideToggle();
        });
        

        // Product filter trigger on mobile
        $("#productInfo").hide();
        $("#moreTrigger").click(function() {
            $("#moreTrigger").text(($("#moreTrigger").text() == 'Read more...') ? 'Read less...' : 'Read more...').fadeIn();
            $("#productInfo").slideToggle();
        });


        $('.berocket_ajax_group_filter_title').remove();

        // Isotope filter for jobs
        var $grid = $('.job-grid').isotope({
            itemSelector: '.isotope-item'
        });

        // store filter for each group
        var filters = {};

        $('.job-filters').on('click', 'p', function(event) {
            var $button = $(event.currentTarget);
            // get group key
            var $buttonGroup = $button.parents('.button-group');
            var filterGroup = $buttonGroup.attr('data-filter-group');
            // set filter for group
            filters[filterGroup] = $button.attr('data-filter');
            // combine filters
            var filterValue = concatValues(filters);
            // set filter for Isotope
            $grid.isotope({ filter: filterValue });
        });

        // change is-checked class on buttons
        $('.button-group').each(function(i, buttonGroup) {
            var $buttonGroup = $(buttonGroup);
            $buttonGroup.on('click', 'p', function(event) {
                $buttonGroup.find('.is-checked').removeClass('is-checked');
                var $button = $(event.currentTarget);
                $button.addClass('is-checked');
            });
        });

        // flatten object by concatting values
        function concatValues(obj) {
            var value = '';
            for (var prop in obj) {
                value += obj[prop];
            }
            return value;
        }


        // Scroll on click
        $(document).on('click', 'a.scroll-link[href^="#"]', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 1000);
        });


        $(document).foundation();

        // *************** SLIDERS ****************
        $('.product-slider').slick({
            slidesToShow: 4,
            infinite: false,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 900000,
            speed: 200,
            prevArrow: '<a href="#" class="arrow arrow--lg arrow--left"><i class="fas fa-chevron-left"></i></a>',
            nextArrow: '<a href="#" class="arrow arrow--lg arrow--right"><i class="fas fa-chevron-right"></i></a>',
            responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2,
                        prevArrow: '<a href="#" class="arrow arrow--sm arrow--left"><i class="fas fa-chevron-left"></i></a>',
                        nextArrow: '<a href="#" class="arrow arrow--sm arrow--right"><i class="fas fa-chevron-right"></i></a>',
                    },
                },
            ],
        });

        $('.most-popular-slider').slick({
            slidesToShow: 1.1,
            infinite: false,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 900000,
            mobileFirst: true,
            speed: 200,
            prevArrow: '<a href="#" class="arrow arrow--sm arrow--left"><i class="fas fa-chevron-left"></i></a>',
            nextArrow: '<a href="#" class="arrow arrow--sm arrow--right"><i class="fas fa-chevron-right"></i></a>',
            responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        arrows: false,
                        rows: 2,
                    },
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2,
                        prevArrow: '<a href="#" class="arrow arrow--lg arrow--left"><i class="fas fa-chevron-left"></i></a>',

                        nextArrow: '<a href="#" class="arrow arrow--lg arrow--right"><i class="fas fa-chevron-right"></i></a>',
                    },
                },
            ],
        });
        $('.slider-3').slick({
            slidesToShow: 1,
            infinite: true,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 900000,
            mobileFirst: true,
            speed: 200,
            prevArrow: '<a href="#" class="arrow arrow--sm arrow--left"><i class="fas fa-chevron-left"></i></a>',
            nextArrow: '<a href="#" class="arrow arrow--sm arrow--right"><i class="fas fa-chevron-right"></i></a>',

            responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2,
                        prevArrow: '<a href="#" class="arrow arrow--lg arrow--left"><i class="fas fa-chevron-left"></i></a>',

                        nextArrow: '<a href="#" class="arrow arrow--lg arrow--right"><i class="fas fa-chevron-right"></i></a>',
                    },
                },
            ],
        });

        $('.image-slider').slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 200,
            arrows: false,
            asNavFor: '.home-text-slider',
        });

        $('.home-text-slider').slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 200,
            arrows: false,
            asNavFor: '.image-slider',
        });

        // Custom arrow buttons for .image-slider and .home-text-slider
        $('.dot-arrow.dot-arrow--left').click(function () {
            $('.image-slider').slick('slickPrev');
            $('.home-text-slider').slick('slickPrev');
        });
    
        $('.dot-arrow.dot-arrow--right').click(function () {
            $('.image-slider').slick('slickNext');
            $('.home-text-slider').slick('slickNext');
        });

        $('.most-popular-slider').on(
            'beforeChange',
            function(event, slick, currentSlide, nextSlide) {}
        );
        $(window).resize(function() {
            $('.product-slider').slick('refresh');
        });

        $(window).resize(function() {
            $('.most-popular-slider').slick('refresh');
        });
        $(window).resize(function() {
            $('.slider-3').slick('refresh');
        });

        $(window)
            .resize(function() {
                // This will fire each time the window is resized:
                if ($(window).width() >= 640) {
                    // if larger or equal
                    $('.read-more-paragraph').css('display', 'inline-block');
                } else {
                    // if smaller
                    $('.read-more-paragraph').css('display', 'none');
                    $('.read-more').text('Read More...');
                }
            })
            .resize(); // This will simulate a resize to trigger the initial run.

        $('.read-more').click(function() {
            if ($('.read-more').text() === 'Read More...') {
                $('.read-more').text('Read Less...');
                $('.read-more-paragraph').css('display', 'inline-block');
            } else {
                $('.read-more').text('Read More...');
                $('.read-more-paragraph').css('display', 'none');
            }
        });

        $(window)
            .resize(function() {
                // This will fire each time the window is resized:
                if ($(window).width() >= 640) {
                    // if larger or equal
                    $('.contact-opening').css('display', 'inline-block');
                } else {
                    // if smaller
                    $('.contact-opening').css('display', 'none');
                    $('.opening-times').text('Opening Times');
                }
            })
            .resize(); // This will simulate a resize to trigger the initial run.

        $('.opening-times').click(function() {
            if ($('.opening-times').text() === 'Opening Times') {
                $('.opening-times').text('Hide...');
                $('.contact-opening').css('display', 'grid');
            } else {
                $('.opening-times').text('Opening Times');
                $('.contact-opening').css('display', 'none');
            }
        });

        // Sticky navi
        $(window).scroll(function() {
            if ($(window).scrollTop() > 130) {
                $('#sticky').removeClass('hidden');
            } else {
                $('#sticky').addClass('hidden');
            }
        });


        // $(function() {

        //     var fixed = document.getElementsByClassName('menu-menu-primary'),
        //         overflow;

        //     $(window).on('load resize', function() {

        //         overflow = fixed.scrollHeight - $('.menu-menu-primary').height();
        //     });

        //     fixed.on('touchmove', function() {

        //         if (overflow) return true;
        //         else return false;
        //     });
        // });

        $(document).on('click', '.nav-item.search', function(e){
            e.preventDefault();
            $('.js-dgwt-wcas-enable-mobile-form').click();
        });

        //Reorder numerical Yith filters
        $('#filter_12680_8 .filter-content, #filter_12680_9 .filter-content, #filter_12680_3 .filter-content').each(function(){
            var integerValuesArray = [];
            var valuesArray = [];
            var orderArray = [];

            //Start by looping through all of the options within a filter set
            $(this).find('.filter-item input').each(function() {
                //Store both its original value, and an integer version of it within an array.
                var value = $(this).val();
                var integerValue = value.replace("-", ".");
                integerValue = integerValue.replace("kg", "");
                integerValue = integerValue.replace("m", "");
                integerValue = integerValue.replace("a", "");
                integerValuesArray.push(integerValue);
                valuesArray.push([value, integerValue]);
            });

            //Use the integer version to sort this array lowest to highest.
            valuesArray = valuesArray.sort(function(a, b){
                return a[1] - b[1];
            });

            //Now go back through all of those options in that filter set, and set a css 'order' on their parent.  Uses the original value to identify which option it is, but then uses the low-high one to work out where it should be within the order.
            $(this).find('.filter-item input').each(function(index) {
                var valueb = $(this).val();
                var positionOrder = '';
                valuesArray.forEach(function(arrayVal, index){
                    if (valueb == arrayVal[0]) {
                        positionOrder = index;
                    }
                });
                $(this).parent().parent().css('order', positionOrder);
            });
        });

    });
});